import React from "react";
import "./../../UaeAttestation/UaeService/UaeService.css";
import AustraliaBloreCertHead from "./AustraliaBloreCertHead";
import AustraliaBloreCertMain from "./AustraliaBloreCertMain";

const AustraliaBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
      <AustraliaBloreCertHead head="Australia Apostille service in Bangalore for certificates" />
      <AustraliaBloreCertMain />
    </div>
  );
};

export default AustraliaBloreCert;
